/*!

=========================================================
* Material Kit PRO React - v1.7.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// nodejs library to set properties for components
import PropTypes from "prop-types";

// @mui/material components
import Button from "@mui/material/Button";
import { styled } from '@mui/material/styles';
import { buttonStyle, classes } from "../../../assets/jss/material-kit-pro-react/components/buttonStyle.jsx";
const RegularButtonRoot = styled(Button)(({ theme }) => buttonStyle(theme));

const RegularButton = React.forwardRef((props, ref) => {
    const {
        round,
        children,
        fullWidth,
        disabled,
        simple,
        size,
        block,
        link,
        justIcon,
        fileButton,
        className,
        color,
        pulse,
        ...rest
    } = props;
    let buttonColor = color;
    if(typeof(color) === "string" && color.indexOf("#") !== -1){
        buttonColor = "custom";
    }
    const btnClasses = classNames({
        [classes.button]: true,
        [classes[size]]: size,
        [classes[buttonColor]]: buttonColor,
        [classes.round]: round,
        [classes.fullWidth]: fullWidth,
        [classes.disabled]: disabled,
        [classes.simple]: simple,
        [classes.block]: block,
        [classes.link]: link,
        [classes.justIcon]: justIcon,
        [classes.fileButton]: fileButton,
        [className]: className,
        [classes.pulse]: pulse
    });
    return (
        <RegularButtonRoot {...rest} ref={ref} className={btnClasses}>
            {children}
        </RegularButtonRoot>
    );
});

RegularButton.defaultProps = {
    pulse: false
}
RegularButton.propTypes = {
    //   color: PropTypes.oneOf([
    //     "primary",
    //     "secondary",
    //     "info",
    //     "success",
    //     "warning",
    //     "danger",
    //     "rose",
    //     "gray",
    //     "white",
    //     "twitter",
    //     "facebook",
    //     "google",
    //     "linkedin",
    //     "pinterest",
    //     "youtube",
    //     "tumblr",
    //     "github",
    //     "behance",
    //     "dribbble",
    //     "reddit",
    //     "instagram",
    //     "instagramGradient",
    //     "transparent",
    //     "customInfo",
    //     "customSuccess",
    //     "customRose",
    //     "blue",
    //     "amazon",
    //     "custom"
    //   ]),
    size: PropTypes.oneOf(["sm","lg", "xl"]),
    simple: PropTypes.bool,
    round: PropTypes.bool,
    fullWidth: PropTypes.bool,
    disabled: PropTypes.bool,
    block: PropTypes.bool,
    link: PropTypes.bool,
    justIcon: PropTypes.bool,
    fileButton: PropTypes.bool,
    children: PropTypes.node,
    className: PropTypes.string,
    pulse: PropTypes.bool
};

export default RegularButton;
